import React, {useMemo} from "react"
import {HistoryRewardType, HistoryRewardTypeCustom} from "../../type/historyReward";
import {HttpService} from "../../service/HttpService";
import {Custom} from "../Custom";
import {HistoryRewardsDetail} from "../../components/Profile/Sections/HistoryRewardsDetail";

interface HistoryRewardsDetailPageProps {
    type: Exclude<HistoryRewardType, HistoryRewardType.ALL>;
}

export const HistoryRewardsDetailPage: React.FC<HistoryRewardsDetailPageProps> =  props  => {
    const customProject = HttpService?.customProject

    function typeChoose(){
        switch (props.type) {
            case HistoryRewardType.CONTEST:
                return HistoryRewardTypeCustom.CONTEST
            case HistoryRewardType.CATALOG:
                return HistoryRewardTypeCustom.CATALOG
            case HistoryRewardType.CATALOG_LOYALTY_COLLECTION:
                return HistoryRewardTypeCustom.CATALOG_LOYALTY_COLLECTION
            case HistoryRewardType.CATALOG_DIGITAL_WALLET:
                return HistoryRewardTypeCustom.CATALOG_DIGITAL_WALLET
            default:
                return HistoryRewardTypeCustom.CONTEST
        }
    }

    const type = useMemo(()=> typeChoose(), [props?.type])

    return (
        <>
            {
                customProject?.customFrontend &&
                customProject?.frontendComponents?.some(component => component?.pathUrl === `/history-reward-${type.toLowerCase()}-detail-custom`)
                    ? <Custom customFrontendUrl={customProject?.customFrontendUrl}
                              type={customProject?.frontendComponents?.find(comp => comp?.pathUrl === `/history-reward-${type.toLowerCase()}-detail-custom`)?.component}
                    />
                    :
                    <HistoryRewardsDetail type={props.type} />
            }
        </>
    )
}